export default __webpack_public_path__ + "static/marcus-230a85137c87eca8f04593e4f8bef8bc.png";